<div class="ap-modal-body pb-4" [class.overflow-hidden]="overflowHidden()">
  <ng-content></ng-content>
</div>
